'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./portfolio/portfolio'));

    var root = document.documentElement;
    var paragraphWidth = document.getElementById('portfolio-paragraph-width').value;
    root.style.setProperty(
        '--portfolio-paragraph-width', paragraphWidth
    );
});
